module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00022.a3c6b2b5.png";